import { defineComponent as _defineComponent } from 'vue'
import NotificationsModal from 'ah-notifications/src/components/notifications/NotificationsModal.vue';
import { useNotificationsStore } from 'ah-notifications/src/store';
import { VButton } from 'ah-common-lib/src/common/components';
import { computed } from 'vue';
import { useRouter } from 'vue-router/composables';
import { Notification, NotificationType } from 'ah-api-gateways';


export default /*#__PURE__*/_defineComponent({
  __name: 'XHedgeNotificationsModal',
  setup(__props) {

const notificationsStore = useNotificationsStore();

const router = useRouter();

const profileLinkNotificationTypes = [NotificationType.CREDIT_PROFILE_CHANGED, NotificationType.LIMITS_PROFILE_CHANGED];

const hasUnreadNotifications = computed(() => notificationsStore.unreadCount > 0);

function navigateToLimitsProfile(item: Notification) {
  if (item.type === NotificationType.CREDIT_PROFILE_CHANGED) {
    router.push('/dashboard/trades/collateral-management');
  } else if (item.type === NotificationType.LIMITS_PROFILE_CHANGED) {
    router.push('/dashboard/trades/position-limits');
  }
}

return { __sfc: true,notificationsStore, router, profileLinkNotificationTypes, hasUnreadNotifications, navigateToLimitsProfile, NotificationsModal, VButton }
}

})